import React, { useCallback } from 'react';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import * as Styles from './PlanTurboFreeDomainStep.styles';
import { Radio } from 'gatorcomponents';

const PlanTurboFreeDomainStep = ({
  locales,
  buttonsProps,
  domainSld,
  handleRedeemDomain,
  setCheckedRadixOption,
  checkedRadixOption,
  loadingRedeem,
}) => {
  const listDomainsRadix = [
    {
      type: 'active',
      domain: `${domainSld}.online`,
    },
    {
      type: 'refuse',
      domain: null,
    },
  ];

  const genericStepProps = useCallback(() => {
    const rightButtonCta = () => {
      const isTurbo = true;
      let redeemRadix = false;

      if (checkedRadixOption.type === 'active') {
        redeemRadix = true;
      }

      handleRedeemDomain(isTurbo, redeemRadix);
    };

    const customButtonsProps = {
      ...buttonsProps,
      rightButton: {
        ...buttonsProps.rightButton,
        onClick: rightButtonCta,
        disabled: !checkedRadixOption.type || loadingRedeem,
      },
    };

    return {
      icon: null,
      title: null,
      description: null,
      imageSrc: null,
      testId: 'plan-turno-free-domain-step',
      buttonsProps: customButtonsProps,
    };
  }, [
    buttonsProps,
    checkedRadixOption,
    handleRedeemDomain,
    loadingRedeem,
  ]);

  return (
    <GenericStep {...genericStepProps()} contentWidthFlexible>
      <Styles.Wrapper>
        <Styles.Title>{locales.title}</Styles.Title>
        <Styles.Description>{locales.description}</Styles.Description>

        {listDomainsRadix && (
          <Styles.OptionsWrapper>
            {listDomainsRadix.map((option) => {
              const { type } = option;
              let titleOption = `${locales.activeRadix.title} "${option.domain}"`;
              let aboutOption = locales.activeRadix.about;

              const isRefuse = option.type === 'refuse';
              if (isRefuse) {
                titleOption = locales.refuseRadix.title;
                aboutOption = locales.refuseRadix.about;
              }

              return (
                <Styles.ListItem key={type}>
                  <Styles.RadioLabel
                    data-testid={`option-${type}`}
                    htmlFor={type}
                    className={checkedRadixOption && checkedRadixOption.type === type ? 'checked' : ''}
                    onClick={() => setCheckedRadixOption(option)}
                    role="button"
                  >
                    <Styles.OptionRow>
                      <Radio
                        id={type}
                        variant="blue"
                        checked={checkedRadixOption && checkedRadixOption.type === type}
                      />
                      <Styles.OptionTitle>
                        {titleOption}
                        <Styles.OptionSubTitle>{aboutOption}</Styles.OptionSubTitle>
                      </Styles.OptionTitle>
                    </Styles.OptionRow>

                  </Styles.RadioLabel>
                </Styles.ListItem>
              );
            })}
          </Styles.OptionsWrapper>
        )}
      </Styles.Wrapper>
    </GenericStep>
  );
};

export default PlanTurboFreeDomainStep;
